export default navigator.userAgent.indexOf('Mac OS X') > -1;
